import React, { Component } from 'react';
import { Row, Col } from 'antd';
import Hints from 'assets/images/hints.svg';

class InfoBar extends Component {
  componentDidMount() {}
  render() {
    return (
      <Row
        type="flex"
        align="middle"
        gutter={14}
        className={
          !this.props.containerStyle ? 'popup-background m-l-0 m-r-0' : ''
        }
        style={{
          backgroundColor: '#E9F5F5',
          ...(this.props.containerStyle || {})
        }}>
        <Col style={{ flex: 1 }}>
          <div style={{ padding: '20px 15px' }}>
            <img
              className="image-filter second"
              src={Hints}
              style={{ height: 14, marginRight: 2, marginBottom: 5 }}
              alt=""
            />
            <span
              style={{ fontWeight: 700 }}
              dangerouslySetInnerHTML={this.props.title}></span>
            <div>
              <span
                style={{ fontSize: '12px' }}
                dangerouslySetInnerHTML={this.props.content}></span>
            </div>
          </div>
        </Col>
        {this.props.image && (
          <Col>
            <div style={{ padding: '20px 15px' }}>
              <img src={this.props.image} alt="" />
            </div>
          </Col>
        )}
      </Row>
    );
  }
}
export default InfoBar;
